var React = require('react');

function Back (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"back"),React.createElement("path",{"d":"M7.658 17.142l14.39 14.385c0.631 0.63 1.654 0.63 2.288 0 0.631-0.63 0.631-1.653 0-2.283l-13.249-13.244 13.247-13.244c0.631-0.63 0.631-1.653 0-2.284-0.631-0.63-1.656-0.63-2.288 0l-14.39 14.385c-0.622 0.623-0.622 1.662 0.002 2.284z","key":1})]);
}

Back.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Back;

Back.default = Back;
